<template>
  <div class="wrap m-a p-r" id="wrap">
    <!--include virtual="/inc/head?v2"-->
    <!--#include virtual="/inc/common/header0526"-->
    <!-- header:end -->
    <div class="product-menu-box p-r" id="menuBox">
      <div class="product-menu-in">
        <div class="f-l sub-title">
          <div class="product-menu-txt">
            <span>{{ $t('common.cookiePolicy.cookie-policy-nav') }}</span>
          </div>
          <div class="f-r product-menu" id="menu">
            <a href="#zero">GENERAL</a>
            <a href="#one">WHAT ARE COOKIES? </a>
            <a href="#two">COOKIES USED BY FJDYNAMICS</a>
            <a href="#three">AUTHENTICATION</a>
            <a href="#four">SECURITY</a>
            <a href="#five">FEATURES AND SERVICES</a>
            <a href="#six">PERFORMANCE</a>
            <a href="#seven">ANALYTICS AND RESEARCH</a>
            <a href="#eight">COOKIES USED ON MOBILE DEVICES</a>
            <a href="#nine">READ OF PARTICULAR COOKIES</a>
            <a href="#ten"
              >COOKIE USE WITHOUT A FJDYNAMICS ACCOUNT <br />
              OR AFTER YOUR LOGOUT</a
            >
            <a href="#eleven">CHANGES TO OUR COOKIE POLICY</a>
            <a href="#twelve">CONTACT</a>
          </div>
        </div>
      </div>
    </div>
    <section class="container-one">
      <div class="top" id="zero">
        <h1>{{ $t('common.cookiePolicy.cookie-policy') }}</h1>
      </div>
      <div class="bottom">
        <div class="bottom-one">
          <h3>
            {{ $t('common.cookiePolicy.cookie-policy-desc') }}
          </h3>
        </div>
      </div>
    </section>
    <section class="container-two clearfix">
      <aside>
        <!-- <h3>This Privacy Policy enables you to understand the followings</h3> -->
        <ul>
          <li class="active">
            <a>{{ $t('common.cookiePolicy.what-are-cookies') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.cookies-used') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.authentication') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.security') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.features-and-services') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.performance') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.analytics-research') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.cookies-on-devices') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.read-cookies') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.cookie-logout') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.changes-cookie') }}</a>
          </li>
          <li>
            <a>{{ $t('common.cookiePolicy.contact') }}</a>
          </li>
        </ul>
      </aside>
      <article>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.what-are-cookies') }}</h2>
          <div class="content">
            <p class="inner-p">
              <span>{{ $t('common.cookiePolicy.what-are-cookies-p1-b') }} </span>
              {{ $t('common.cookiePolicy.what-are-cookies-p1') }}
            </p>
            <p class="inner-p">
              {{ $t('common.cookiePolicy.what-are-cookies-p2') }}
            </p>
            <p class="inner-p">
              {{ $t('common.cookiePolicy.what-are-cookies-p3') }}
            </p>
          </div>
        </div>

        <div class="card">
          <h2>{{ $t('common.cookiePolicy.cookies-used') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.cookies-used-p1') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.authentication') }}</h2>
          <div class="content">
            <p class="inner-p">
              {{ $t('common.cookiePolicy.authentication-p1') }}
            </p>
            <p class="inner-p">
              {{ $t('common.cookiePolicy.authentication-p2') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.security') }}</h2>
          <div class="content">
            <p class="inner-p">
              {{ $t('common.cookiePolicy.security-p1') }}
            </p>
            <p class="inner-p">
              {{ $t('common.cookiePolicy.security-p2') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.features-and-services') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.features-services-p1') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.performance') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.performance-p1') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.analytics-research') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.analytics-research-p1') }}
            </p>
          </div>
        </div>

        <div class="card">
          <h2>{{ $t('common.cookiePolicy.cookies-on-devices') }}</h2>
          <div class="content">
            <p class="inner-p">
              {{ $t('common.cookiePolicy.cookies-on-devices-p1') }}
            </p>
            <p class="inner-p">
              {{ $t('common.cookiePolicy.cookies-on-devices-p2') }}
            </p>
          </div>
        </div>
        <!-- .card>h2+.content>p -->
        <div class="card">
          <h2>{{ $t('common.cookiePolicy.read-cookies') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.read-cookies-p1') }}
            </p>
          </div>
        </div>
        <div class="card">
          <h2 style="font-size: 24px">{{ $t('common.cookiePolicy.cookie-logout') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.cookie-logout-p1') }}
            </p>
            <ul style="padding-top: 30px">
              <li>{{ $t('common.cookiePolicy.cookie-logout-p2') }}</li>
              <li>{{ $t('common.cookiePolicy.cookie-logout-p3') }}</li>
              <li>{{ $t('common.cookiePolicy.cookie-logout-p4') }}</li>
              <li>{{ $t('common.cookiePolicy.cookie-logout-p5') }}</li>
            </ul>
          </div>
        </div>

        <div class="card">
          <h2>{{ $t('common.cookiePolicy.changes-cookie') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.changes-cookie-p1') }}
            </p>
          </div>
        </div>

        <div class="card last-one">
          <h2>{{ $t('common.cookiePolicy.contact') }}</h2>
          <div class="content">
            <p>
              {{ $t('common.cookiePolicy.contact-p1') }}
              <br /><span>{{ $t('common.cookiePolicy.contact-p2') }}</span>
            </p>
          </div>
        </div>
        <!-- <div style="height: 600px;"></div> -->
      </article>
    </section>
    <!--include virtual="/inc/foot"-->
    <!--#include virtual="/inc/common/footer0526"-->
    <!-- footer:end -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    mounted() {
      this.chooseTabs()
      window.addEventListener('scroll', this.addClientLight)
    },
    methods: {
      chooseTabs() {
        const tabList = document.querySelectorAll('aside li a')
        const cardContainer = document.querySelectorAll('.card')

        for (let i = 0; i < tabList.length; i++) {
          const currentLi = tabList[i]
          currentLi.id = i
          currentLi.addEventListener('click', function () {
            for (let j = 0; j < tabList.length; j++) {
              tabList[j].className = ''
            }
            this.className = 'active'
            document.documentElement.scrollTop = cardContainer[i].offsetTop + 20
          })
        }
      },
      // 滚动滚轮获取高度并给左侧导航增加高亮
      addClientLight() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        // 获取各个内容高度
        const tabList = document.querySelectorAll('aside li a')
        const cardContainer = document.querySelectorAll('.card')
        if (scrollTop < cardContainer[1].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[0].classList.add('active')
        } else if (scrollTop > cardContainer[1].offsetTop && scrollTop < cardContainer[2].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[1].classList.add('active')
        } else if (scrollTop > cardContainer[2].offsetTop && scrollTop < cardContainer[3].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[2].classList.add('active')
        } else if (scrollTop > cardContainer[3].offsetTop && scrollTop < cardContainer[4].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[3].classList.add('active')
        } else if (scrollTop > cardContainer[4].offsetTop && scrollTop < cardContainer[5].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[4].classList.add('active')
        } else if (scrollTop > cardContainer[5].offsetTop && scrollTop < cardContainer[6].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[5].classList.add('active')
        } else if (scrollTop > cardContainer[6].offsetTop && scrollTop < cardContainer[7].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[6].classList.add('active')
        } else if (scrollTop > cardContainer[7].offsetTop && scrollTop < cardContainer[8].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[7].classList.add('active')
        } else if (scrollTop > cardContainer[8].offsetTop && scrollTop < cardContainer[9].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[8].classList.add('active')
        } else if (scrollTop > cardContainer[9].offsetTop && scrollTop < cardContainer[10].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[9].classList.add('active')
        } else if (scrollTop > cardContainer[10].offsetTop && scrollTop < cardContainer[11].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[10].classList.add('active')
        } else if (scrollTop > cardContainer[11].offsetTop) {
          tabList.forEach((item) => {
            item.classList = []
          })
          tabList[11].classList.add('active')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @media screen and (max-width: 768px) {
    .return-to-top-btn {
      width: 52px;
      height: 52px;
      bottom: 100px;
      right: 32px;
      border-radius: 100%;
    }
    .return-to-top-btn .triangle-icon {
      width: 30px;
      height: 30px;
      background-image: url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h50v50H0z'/%3E%3C/defs%3E%3Cg transform='rotate(90 25 25)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M13 24.896L30.764 6a3.715 3.715 0 0 1 .001 5.09l-15.37 16.35L13 24.896zM30.987 44L13.02 24.878l2.392-2.545L30.99 38.9a3.72 3.72 0 0 1-.003 5.1z' fill='%23333' fill-rule='nonzero' mask='url(%23b)'/%3E%3C/g%3E%3C/svg%3E");
    }
  }
  .product-menu-txt {
    position: relative;
    padding-right: 0.2rem;
  }
  .product-menu-txt i {
    transition: all 0.1s;
    position: absolute;
    top: 0.4rem;
    left: 100%;
    right: 0;
    display: block;
    width: 0.23rem;
    height: 0.14rem;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAOCAMAAADzLXfBAAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMA+z0JA6YG9vLDr6CHgGtnX1lUTkM17su8t5mTjHpzZEgt7lBQUwAAAHZJREFUGNN1zVcOg1AMRNExJRB6Ta93/4tM0RN6IXC+Rh7Z1pqwvm80EwzSc8c2lC+KsVEaU1d44/67lXLwihzr3LmE4/TjhLVyhoTMFWdoNHkYWfQJF6jl6Y34XRRQ6Udn5CrhppnW2MNVfxqg1IKKQosCL78Ae9EG0u658ngAAAAASUVORK5CYII=')
      no-repeat center;
    background-size: 100% auto;
  }
  .product-menu-in {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    position: relative;
  }
  .product-menu-box {
    height: 50px;
    width: 100%;
    z-index: 97;
    line-height: 50px;
    top: 3.958vw;
    left: 0;
    background: #5a5a5a;
    position: fixed !important;
  }
  .product-menu-in a {
    color: #fff;
  }
  .product-menu-in a:hover {
    color: #ddd;
  }
  .product-menu-box .sub-title {
    font-size: 16px;
    color: #fff;
    white-space: nowrap;
    text-transform: uppercase;
  }
  .product-menu {
    margin-right: 150px;
  }
  .product-menu a {
    display: inline-block;
    margin-left: 50px;
    font-size: 16px;
  }
  .product-menu a:nth-child(1) {
    margin-left: 0;
  }
  section {
    color: #666666;
    font-size: 16px;
    line-height: 22px;
    width: 1200px;
    margin: 0 auto;
  }
  section h1,
  h2,
  section h3,
  section h5 {
    font-family: 'Alibaba Sans Bold';
    color: #333;
  }
  .product-menu {
    display: none;
  }
  .container-one {
    margin-top: 150px;
  }
  .container-one .top {
    padding: 32px 0 35px;
    line-height: 56px;
    text-align: center;
    font-size: 36px;
    border-bottom: 1px solid #d6d6d6;
  }
  .container-one .top h1 {
    font-size: 36px;
  }
  .container-one .bottom {
    margin-top: 61px;
  }
  .container-one h3 {
    margin-bottom: 36px;
    color: #666;
  }
  .container-one .bottom-two {
    margin-top: 36px;
  }
  .container-two {
    margin-top: 115px;
    padding-bottom: 51px;
  }
  aside {
    width: 382px;
    float: left;
    position: sticky;
    top: 180px;
    margin-bottom: 50px;
    height: 700px;
  }
  aside h3 {
    width: 382px;
    line-height: 20px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  aside ul {
    margin-top: 27px;
  }
  aside li {
    margin-bottom: 18px;
    line-height: 17px;
    position: relative;
    margin-left: 20px;
  }
  aside li a {
    display: inline-block;
    width: 100%;
    color: #aaaaaa;
  }
  aside li a:hover {
    color: #333333;
  }
  aside li::before {
    position: absolute;
    left: -20px;
    top: 7px;
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #aaa;
  }
  aside li .active {
    color: #333333;
  }
  article {
    float: right;
    width: 712px;
  }
  article h2 {
    font-size: 22px;
  }
  article .card {
    font-size: 14px;
    margin-bottom: 50px;
  }
  article .content {
    margin-top: 30px;
  }
  .content-list {
    padding: 30px 0;
  }
  article .content li {
    margin-bottom: 20px;
    line-height: 20px;
    margin-left: 12px;
    position: relative;
  }
  article .content li::before {
    position: absolute;
    left: -12px;
    top: 8px;
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #666666;
  }
  article .content .inner-h3 {
    margin-top: 30px;
    color: #666;
  }
  article .content .inner-p {
    margin-top: 22px;
  }
  article .content span {
    color: #333333;
    font-family: 'Alibaba Sans Bold';
  }
  article .last-one::after {
    content: '';
    display: block;
    height: 600px;
  }
  .clearfix:after,
  .clearfix:before {
    content: '';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .clearfix {
    *zoom: 1;
  }
</style>
